import styled from "styled-components";
import type { SelectInputWithLabelProps } from "@vfuk/core-select-input-with-label/dist/SelectInputWithLabel.types";

const FloatingLabelSelectStyles = styled.div<SelectInputWithLabelProps>`
  input {
    padding-top: 11px;
  }

  label {
    margin-bottom: -20px;
    border-radius: 6px;
    z-index: 2;
    margin-left: 6px;
    font-size: 16px;
    background-color: ${(props) =>
      props.state === "disabled" ? "#f2f2f2" : "white"};
    padding: 0px;
    height: 25px;
    padding-left: 5px;
    padding-right: 5px;
  }
`;

export default FloatingLabelSelectStyles;
